import { lazy, ReactNode, Suspense, useEffect, useState } from 'react';
import { getRegion, RegionCode } from '@steelbuy/ts-shared';
import { LoadingSpinnerOverlay } from '@steelbuy/ui-primitive';

export enum Page {
    ACCEPTABLE_USE = 'ACCEPTABLE_USE',
    CONTACT_DETAILS = 'CONTACT_DETAILS',
    PRIVACY_POLICY = 'PRIVACY_POLICY',
    TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
}

const regionCountryLookup = {
    [RegionCode.de]: 'germany',
    [RegionCode.en]: 'uk',
    [RegionCode.es]: 'spain',
};

const pageFileLookup = {
    [Page.ACCEPTABLE_USE]: 'AcceptableUse',
    [Page.CONTACT_DETAILS]: 'ContactDetails',
    [Page.PRIVACY_POLICY]: 'PrivacyPolicy',
    [Page.TERMS_AND_CONDITIONS]: 'TermsAndConditions',
};

// dynamic paths can only be one folder deep
const importView = (page: Page, region: RegionCode) =>
    lazy(() => import(`./${regionCountryLookup[region]}/${pageFileLookup[page]}.tsx`));

export const LegalPages = ({ page }: { page: Page }) => {
    const [legalPage, setLegalPage] = useState<ReactNode | undefined>();

    useEffect(() => {
        const View = importView(page, getRegion().regionCode);
        setLegalPage(<View />);
    }, [page]);

    return <Suspense fallback={<LoadingSpinnerOverlay />}>{legalPage}</Suspense>;
};
